import { Map } from "immutable";
import isDeepEqual from "stores/isDeepEqual";
import isEqualForSearch from "views/stores/isEqualForSearch";
import AggregationWidgetConfig from "./AggregationWidgetConfig";
import Widget, { widgetAttributesForComparison } from "../widgets/Widget";
const _AggregationWidget = class _AggregationWidget extends Widget {
  constructor(id, config, filter, timerange, query, streams, streamCategories, filters, description, context) {
    super(
      id,
      _AggregationWidget.type,
      config,
      filter,
      timerange,
      query,
      streams,
      streamCategories,
      filters,
      description,
      context
    );
  }
  static fromJSON(value) {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = value;
    return new _AggregationWidget(
      id,
      AggregationWidgetConfig.fromJSON(config),
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
  toBuilder() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this._value;
    return new Builder(
      Map({ id, config, filter, timerange, query, streams, stream_categories, filters, description, context })
    );
  }
  static builder() {
    return new Builder();
  }
  equals(other) {
    if (other instanceof _AggregationWidget) {
      return [...widgetAttributesForComparison, "description", "context"].every(
        (key) => isDeepEqual(this[key], other[key])
      );
    }
    return false;
  }
  equalsForSearch(other) {
    if (other instanceof _AggregationWidget) {
      return widgetAttributesForComparison.every((key) => isEqualForSearch(this[key], other[key]));
    }
    return false;
  }
};
_AggregationWidget.type = "AGGREGATION";
_AggregationWidget.defaultTitle = "Untitled Aggregation";
let AggregationWidget = _AggregationWidget;
export {
  AggregationWidget as default
};
class Builder extends Widget.Builder {
  build() {
    const { id, config, filter, timerange, query, streams, stream_categories, filters, description, context } = this.value.toObject();
    return new AggregationWidget(
      id,
      config,
      filter,
      timerange,
      query,
      streams,
      stream_categories,
      filters,
      description,
      context
    );
  }
}
